import { ActionType } from "../../../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../../../react-core/Flux/BaseStore";
import { AreaGroupModel } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/AreaGroupModel";
import { InsightsDispatcher, InvestmentRegionAllocationDispatcher } from "./Variable";
import { FluxResponse } from "../../../../../../../Shared/Stores/FluxResponse";
import { InvestmentGeographicAllocationModel } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/InvestmentGeographicAllocationModel";

export interface InsightsStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    regionGroupData?: Array<AreaGroupModel>;
}

export interface InvestmentRegionAllocationStore {
    isLoading?: boolean;
    actionType: ActionType;
    investmentRegionAllocation?: Array<InvestmentGeographicAllocationModel>;
}

export class InsightsStoreStatic extends BaseStore<InsightsStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(InsightsDispatcher, (actionData) => this.onInsightsStoreResponse(actionData));
    }

    public getLastResult(): InsightsStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): InsightsStoreStaticState {
        return { actionType: ActionType.Loading };
    }

    public getRegionGroup() {
        return this.getState().regionGroupData;
    }

    private onInsightsStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({
                    actionType: actionData.actionType,
                    isLoading: false,
                    regionGroupData: actionData.payload,
                });
                break;
            case ActionType.Error:
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}

export class InvestmentRegionAllocationStatic extends BaseStore<InvestmentRegionAllocationStore> {
    constructor() {
        super();
        this.subscribeToDispatcher(InvestmentRegionAllocationDispatcher, (data) =>
            this.onInvestmentRegionAllocationStoreResponse(data)
        );
    }

    onInvestmentRegionAllocationStoreResponse(data: FluxResponse<Array<InvestmentGeographicAllocationModel>>): void {
        switch (data.actionType) {
            case ActionType.Success:
                this.setState({
                    investmentRegionAllocation: data.payload,
                    isLoading: false,
                    actionType: ActionType.Success,
                });
        }
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    public getData() {
        return this.getState().investmentRegionAllocation;
    }

    public resetData() {
        return this.resetState();
    }

    protected getDefaultState(): InvestmentRegionAllocationStore {
        return {
            investmentRegionAllocation: [],
            isLoading: true,
            actionType: ActionType.Loading,
        };
    }
}
